module.exports = __webpack_public_path__ + "img/Weapon_278.cb64c87f.png";